/* EXEMPLE : 
import '@/jquery-ui/ui/widgets/tabs';
import '@/jquery-ui/ui/widgets/accordion';

$(document).ready(function(){
    $(".l-tabs").tabs();
    $( ".l-accordion" ).accordion({
        header: ".accordion-title"
    });
});
*/